<template>
    <div>
        <v-container grid-list-md>
            <loading-component :value="loading"></loading-component>
            <h2>Ticket {{ticket.id}}</h2>
            <v-layout row wrap text-center-xs>
                <v-flex xs6>
                    <v-card>
                        <v-card-title>
                            <h3>Info</h3>

                        </v-card-title>
                        <v-card-text>

                            <v-layout row style="margin: 10px 0">
                                <v-flex xs3>
                                    <b>Name</b>
                                </v-flex>
                                <v-flex xs3>
                                    <router-link v-if="ticket.author_type === 'Captain'"
                                                 :to="`/captains/${author.id}`" target="_blank">
                                        <span>{{author.first_name + ' ' + author.last_name}}</span>
                                    </router-link>
                                    <router-link v-else-if="ticket.author_type === 'Passenger'"
                                                 :to="`/passengers/${author.id}`" target="_blank">
                                        <span>{{author.first_name + ' ' + author.last_name}}</span>
                                    </router-link>
                                    <span v-else>{{author.first_name + ' ' + author.last_name}}</span>
                                </v-flex>
                                <v-flex xs3>
                                    <b>Type</b>
                                </v-flex>
                                <v-flex xs3>
                                    <span>{{ticket.author_type}} {{ticket.author_id}}</span>
                                </v-flex>
                            </v-layout>
                            <v-layout row style="margin: 10px 0">
                                <v-flex xs3>
                                    <b>Rate</b>
                                </v-flex>
                                <v-flex xs4>
                                    <Rate :rate="ticket.rate"></Rate>
                                </v-flex>
                            </v-layout>
                            <v-layout row style="margin: 10px 0">
                                <v-flex xs3>
                                    <b>Res. Tickets</b>
                                </v-flex>
                                <v-flex xs3>
                                    <span style="color: green">{{ticket.resolved}}</span>
                                </v-flex>
                                <v-flex xs3>
                                    <b>Unres. Tickets</b>
                                </v-flex>
                                <v-flex xs3>
                                    <span style="color: red">{{ticket.unresolved}}</span>
                                </v-flex>
                            </v-layout>
                            <v-layout row style="margin: 10px 0">
                                <v-flex xs3>
                                    <b>Ticket Type</b>
                                </v-flex>
                                <v-flex xs9>
                                    <span>{{ticket_type.title}}/{{ticket_type.details}}</span>
                                </v-flex>
                            </v-layout>
                            <v-layout row style="margin: 10px 0">
                                <v-flex xs3>
                                    <b>Created At</b>
                                </v-flex>
                                <v-flex xs4>
                                    {{moment(ticket.created_at).format('DD MMM YYYY hh:mm A')}}
                                </v-flex>
                            </v-layout>
                            <v-layout
                                    v-if="(ticket.subject_type === 'App\\Models\\Ride\\Ride' || ticket.subject_type === 'App\\Models\\Ride\\Booking') && ride_id"
                                    row style="margin: 10px 0">
                                <v-btn @click="ride_page_dialog = true">Show Ride</v-btn>
                            </v-layout>
                            <template v-else-if="ticket.subject_type === 'App\\Models\\Passenger\\Passenger'">
                                <b>On Passenger</b>
                                <router-link :to="{name: 'PassengerProfile', params: {id: ticket.subject_id} }"
                                             target="_blank">
                                    {{ticket.subject.first_name}} {{ticket.subject.last_name}}
                                </router-link>
                            </template>
                            <template v-else-if="ticket.subject_type && ticket.subject_type.search('UserCheckLog') >= 0">
                                <p>
                                    <b>( stored time)</b> :
                                    {{ticket.subject.from_datetime}} -> {{ticket.subject.to_datetime}}
                                </p>
                            </template>
                            <template v-else-if="ticket.subject_type === 'App\\Models\\Captain\\Captain'">
                                <b>On Captain</b>
                                <router-link :to="{name: 'CaptainProfile', params: {id: ticket.subject_id} }"
                                             target="_blank">
                                    {{ticket.subject.first_name}} {{ticket.subject.last_name}}
                                </router-link>
                            </template>
                            <v-flex xs12>
                                <h4>Assigned to
                                    <template v-if="!ticket.user_id">
                                        No one
                                    </template>
                                    <template v-else>
                                        {{ticket.user.first_name}} {{ticket.user.last_name}}
                                    </template>
                                </h4>
                            </v-flex>
                        </v-card-text>
                    </v-card>
                    <v-card style="margin-top: 10px">
                        <v-card-title>
                            <h3>Ticket Path</h3>
                        </v-card-title>
                        <v-card-text>
                            <v-treeview :items="ticket.path" open-all></v-treeview>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex xs6>
                    <v-card>
                        <v-card-title>
                            <h3>Take Action</h3>
                        </v-card-title>
                        <v-card-text>
                            <v-select
                                    label="Select Action"
                                    :items="allowedActions"
                                    v-model="selected_action"
                                    item-text="title"
                                    item-value="title"
                            ></v-select>
                        </v-card-text>
                    </v-card>
                    <v-card style="margin-top: 10px">
                        <v-card-title>
                            <h3>Ticket Report</h3>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table
                                    :pagination.sync="reportingPagination"
                                    :items="ticketReports"
                                    class="elevation-1"
                                    :headers="reportHeader">
                                <template v-slot:items="props">
                                    <td>
                                        {{props.item.user}}
                                    </td>
                                    <td>
                                        {{props.item.problem || "N\\A"}}
                                    </td>
                                    <td>
                                        {{props.item.solution || "N\\A"}}
                                    </td>
                                    <td>
                                        {{props.item.date}}
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                    <v-card style="margin-top: 10px">
                        <v-card-title>
                            <h3>Ticket Events Log</h3>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table :items="ticket.events" class="elevation-1">
                                <template v-slot:items="props">
                                    <td class="text-xs-left">{{ props.item.id }}</td>
                                    <td class="text-xs-left">{{ props.item.user.first_name }} {{
                                        props.item.user.last_name
                                        }}
                                    </td>
                                    <td class="text-xs-left">{{ props.item.action.title }}</td>
                                    <td class="text-xs-left">{{ moment(props.item.created_at)
                                        .format('DD MMM YYYY hh:mmA')}}
                                    </td>
                                    <td class="text-xs-left">{{ props.item.extra }}
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                    <v-card style="margin-top: 10px">
                        <v-card-title>
                            <h3>Related Tickets</h3>
                        </v-card-title>
                        <v-card-text>
                            No related tickets
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-dialog v-model="dialog" max-width="500px">
                <v-card>
                    <v-card-title>
                        <p v-if="selected_action === 'CLOSE_TICKET'">Are you sure you want to close this ticket ?</p>
                        <p v-if="selected_action === 'REOPEN_TICKET'">Are you sure you want to reopen this ticket ?</p>
                        <p v-if="selected_action === 'SEND_MESSAGE'">Enter message to send</p>
                        <p v-if="selected_action === 'VOUCHER_GIFT'">Voucher gift</p>
                        <p v-if="selected_action === 'WALLET_BONUS'">Wallet bonus</p>
                        <p v-if="selected_action === 'EDIT_RIDE'">Edit ride</p>
                        <p v-if="selected_action === 'GIVE_PENALTY'">Give Penalty</p>
                        <p v-if="selected_action === 'REVOKE_PENALTY'">Revoke Penalty</p>
                        <p v-if="selected_action === 'FREE_RIDE'">Are you sure you want to give free ride voucher?</p>
                        <p v-if="selected_action === 'REASSIGN_TICKET'">Are you sure you want to reassign the
                            ticket?</p>
                        <p v-if="selected_action === 'ADD_NOTE'">Adding note to ticket</p>
                        <p v-if="selected_action === 'CHANGE_CHECK_LOG'">Change Check Log Time</p>
                        <p v-if="selected_action === 'REVOKE_RIDE'">Revoke ride</p>
                        <p v-if="selected_action === 'JUSTIFY_CHECK_LOG'">Justify Check Log</p>
                    </v-card-title>

                    <v-card-text v-if="selected_action === 'CLOSE_TICKET' || selected_action === 'REASSIGN_TICKET'">
                        <v-textarea label="Problem" v-model="action.problem"
                                    :rules="[val => !!val || 'Required']"
                                    placeholder="Kindly describe the problem"
                        />
                        <v-textarea label="Measures Taken" v-model="action.solution"
                                    :rules="[val => !!val || 'Required']"
                                    placeholder="Kindly describe what you've done in order to solve the problem"
                        />
                    </v-card-text>

                    <v-card-text v-if="selected_action === 'ADD_NOTE'">
                        <v-textarea label="Note" v-model="action.note"
                                    :rules="[val => !!val || 'Required']"
                                    placeholder="Enter your note here"/>
                    </v-card-text>

                    <v-card-text v-if="selected_action === 'SEND_MESSAGE'">
                        <v-textarea label="Message" v-model="action.message"
                                    :rules="[val => !!val || 'Required Field']"/>
                    </v-card-text>

                    <v-card-text v-if="selected_action === 'REOPEN_TICKET' || selected_action === 'REASSIGN_TICKET'">
                        <choose-user-multi label="User" v-model="action.user_id" :multi="false"/>
                    </v-card-text>

                    <v-card-text v-if="selected_action === 'VOUCHER_GIFT'">
                        <v-select v-model="action.type"
                                  :items="['PERCENTAGE','CASH']"
                                  label="Type"/>
                        <v-text-field v-model="action.amount"
                                      label="Amount"/>
                    </v-card-text>

                    <v-card-text v-if="selected_action === 'FILL_WALLET'">
                        <v-text-field v-model="action.amount"
                                      label="Amount (SYP)"/>
                    </v-card-text>

                    <v-card-text v-if="selected_action === 'GIVE_PENALTY'">
                        <v-text-field v-model="action.unit"
                                      :items="['CASH','KM','HOUR']"/>
                        <v-text-field v-model="action.amount"
                                      label="Amount"/>
                    </v-card-text>

                    <v-card-text v-if="selected_action === 'REVOKE_PENALTY'">
                        <p>Are you sure you want to revoke penalty on this booking?</p>
                    </v-card-text>

                    <v-card-text v-if="selected_action === 'REVOKE_RIDE'">
                        <p>Are you sure you want to revoke ride?</p>
                        <p>Note: if this ride is pooling all bookings will be revoked</p>
                    </v-card-text>

                    <v-card-text v-if="selected_action === 'EDIT_RIDE'">
                        <div>
                            <h3>Update Meter Price</h3>
                            <v-form ref="meter_form" v-model="valid">
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-text-field :rules="numberRules" v-model="action.meter_price"
                                                      :label="'Meter Price' + editRideExplain"></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex>
                                        <v-select
                                                :items="ride.bookings.length === 1 ? (action.meter_price > ride.meter.meter_price ? ['Passenger', 'Wasilni'] : ['Captain', 'Wasilni']) : ['Wasilni']"
                                                label="Refunder"
                                                v-model="action.refunder"
                                                :rules="requiredRules"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-btn @click="submit(true)">Submit</v-btn>
                            </v-form>
                        </div>
                        <v-divider style="margin: 10px"></v-divider>
                        <div>
                            <h3>Update Paid Amount</h3>
                            <v-form ref="paid_form" v-model="valid">
                                <v-layout row>
                                    <v-flex>
                                        <v-select
                                                :items="ride.bookings"
                                                label="Passenger"
                                                v-model="selected_booking"
                                                item-text="passenger_name"
                                                return-object
                                                :rules="requiredRules"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-text-field :rules="numberRules" v-model="action.paid"
                                                      :label="'Paid Amount' + editBookingExplain"></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-btn @click="submit(false)">Submit</v-btn>
                            </v-form>
                        </div>
                    </v-card-text>
                    <v-card-text v-if="selected_action === 'CHANGE_CHECK_LOG'">
                        Original : {{ticket.subject.from_datetime}} -> {{ticket.subject.to_datetime}}
                        <choose-time v-model="action.from_time" label="New Start : "/>
                        <choose-time v-model="action.to_time" label="New End : "/>
                    </v-card-text>
                    <v-card-actions v-if="selected_action !== 'EDIT_RIDE'">
                        <v-spacer></v-spacer>
                        <v-btn flat @click="dialog = false">Close</v-btn>
                        <v-btn flat color="primary" @click="submit">Continue</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
        <v-dialog
                v-if="(ticket.subject_type === 'App\\Models\\Ride\\Ride' || ticket.subject_type === 'App\\Models\\Ride\\Booking') && ride_id"
                fullscreen lazy v-model="ride_page_dialog">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="ride_page_dialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Ride Details</v-toolbar-title>
                </v-toolbar>
                <ride-page :ride_id="ride_id"/>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Rate from "@/components/wasilni/Rate";
    import DataTable from "@/components/wasilni/DataTable";
    import LoadingComponent from "@/components/LoadingComponent";
    import ChooseVoucher from "@/components/wasilni/input/ChooseVoucher";
    import Bonus from "@/components/accounting/Bonus";
    import RidePage from "@/views/RidePage";
    import Penalty from "@/components/accounting/Penalty";
    import ChooseUserMulti from "@/components/wasilni/input/ChooseUserMutli";
    import ChooseTime from "@/components/wasilni/input/ChooseTime";

    export default {
        name: "Ticket",
        title: "Ticket",
        components: {
            ChooseTime,
            ChooseUserMulti, Penalty, RidePage, Bonus, ChooseVoucher, LoadingComponent, DataTable, Rate
        },
        mounted() {
            this.loading = true;
            this.axios.get(`ticket/${this.$route.params.id}`)
                .then(res => {
                    this.ticket = res.data.data;
                    if (this.ticket.type_id === this.$store.state.user.settings.CHANGE_CHECK_LOG.id) {
                        this.action.from_time = moment(this.ticket.subject.from_datetime).format("HH:mm");
                        this.action.to_time = moment(this.ticket.subject.to_datetime).format("HH:mm");
                    }
                    this.ticket.author_type = this.ticket.author_type.substr(this.ticket.author_type.lastIndexOf("\\") + 1, this.ticket.author_type.length - this.ticket.author_type.lastIndexOf("\\") - 1);
                    this.axios.get(`ticket_type/${this.ticket.type_id}`)
                        .then(res => {
                            this.ticket_type = res.data.data;
                            this.ride_id = (this.ticket.subject_type === 'App\\Models\\Ride\\Ride' ? this.ticket.subject_id : (this.ticket.ride_id));
                        })
                        .catch(err => console.log(err.message))
                        .finally(() => this.loading = false);
                })
                .catch(err => {
                    console.log(err.message);
                    this.loading = false;
                });
        },
        data() {
            return {
                reportingPagination: {
                    descending: true,
                    sortBy: 'date'

                },
                reportHeader: [
                    {text: 'User', value: 'user'},
                    {text: 'Problem', value: 'problem'},
                    {text: 'Solution', value: 'solution'},
                    {text: 'Date', value: 'date'}
                ],
                ride_page_dialog: false,
                numberRules: [
                    v => !!v || 'Required field',
                    v => /^[0-9]*$/.test(v) || 'invalid value'
                ],
                requiredRules: [
                    v => !!v || 'Field is required'
                ],
                selected_booking: {},
                dialog: false,
                loading: false,
                selected_action: null,
                ticket: {
                    author: {},
                    rate: {},
                    events: [],
                    path: [],
                    user: {},
                    subject: {}
                },
                ticket_type: {
                    actions: []
                },
                actions: {},
                action: {
                    meter_price: 0,
                    from_time: "00:00",
                    to_time: "00:00"
                },
                ride: {
                    bookings: [{
                        id: null,
                        passenger: {
                            id: null,
                            username: null,
                            first_name: null,
                            last_name: null,
                            whatsapp_number: null,
                        }
                    }],
                    id: null,
                    meter: {
                        km_count: null,
                        elapsed_time: null,
                        waiting_time: null,
                        meter_price: null
                    }
                },
                valid: false,
                ride_id: null
            };
        },
        methods: {
            submit(meter_change = null) {
                if (this.selected_action === 'EDIT_RIDE' && (meter_change === false && !this.$refs.paid_form.validate() || meter_change === true && !this.$refs.meter_form.validate())) {
                    window.getApp.$emit("SHOW_TOAST", 'invalid info', "red");
                    return;
                }

                if (this.selected_action === 'EDIT_RIDE') {
                    if (meter_change) {
                        this.action.ride_id = this.ride.id;
                        delete this.action.paid;
                    } else {
                        this.action.booking_id = this.selected_booking.id;
                        delete this.action.meter_price;
                    }
                }
                if (this.selected_action === 'JUSTIFY_CHECK_LOG') {
                    this.action = [];
                }

                this.loading = true;
                this.axios.put(`/ticket/${this.$route.params.id}/action`, {
                    action_id: this.ticket_type.actions.filter(({title}) => title === this.selected_action)[0].id,
                    data: this.action
                }).then(
                    ({data: {data: event}}) => {
                        if (this.selected_action === 'REOPEN_TICKET')
                            this.ticket = Object.assign({}, this.ticket, {
                                status: "PROCESSING"
                            });
                        else if (this.selected_action === "CLOSE_TICKET")
                            this.ticket = Object.assign({}, this.ticket, {
                                status: "SOLVED"
                            });
                        window.getApp.$emit("SHOW_TOAST", "Done");
                        this.dialog = false;
                        this.selected_booking = {};
                        this.action = {};
                        this.ticket = Object.assign(
                            {}, this.ticket, {
                                events: [event, ...this.ticket.events]
                            }
                        )
                    }
                ).catch(
                    ({response}) => window.getApp.$emit("SHOW_TOAST", response.data.message, "red")
                ).finally(
                    () => this.loading = false
                )
            }
        },
        computed: {
            ticketReports() {
                const reportEvents = this.ticket
                    .events
                    .filter(({action: {title}}) => title === "REASSIGN_TICKET" || title === "CLOSE_TICKET");

                const noteEvents = this.ticket
                    .events
                    .filter(({action: {title}}) => title === "ADD_NOTE");
                return [...reportEvents.map(event => ({
                    user: event.user.first_name + ' ' + event.user.last_name,
                    problem: event.extra.problem,
                    solution: event.extra.solution,
                    date: event.created_at
                })), ...noteEvents.map(event => ({
                    user: event.user.first_name + ' ' + event.user.last_name,
                    problem: "(NOTE)",
                    solution: event.extra.note,
                    date: event.created_at
                }))];
            },
            author() {
                if (this.ticket.author.first_name)
                    return this.ticket.author;
                else
                    return this.ticket.author.passenger || this.ticket.author.captain || {};
            },
            editRideExplain() {
                return (this.ride.meter ? (this.ride.meter.meter_price < this.action.meter_price ? ' ( CAPTAIN REFUND)' :
                    (this.ride.meter.meter_price > this.action.meter_price ? ' ( PASSENGER REFUND)' : '')) : '');
            },
            editBookingExplain() {
                return (this.selected_booking ? (this.selected_booking.paid < this.action.paid ? ' (CAPTAIN Cash out)' :
                    (this.selected_booking.paid > this.action.paid ? ' (Passenger Cash out)' : '')) : '');
            },
            allowedActions() {
                if (!this.ticket_type.actions)
                    return [];

                const not = [];
                if (this.ticket.status === 'PROCESSING')
                    not.push(2);
                if (this.ticket.status === "SOLVED")
                    not.push(1, 3, 4, 5, 6, 7, 8, 9, 10, 11);

                return this.ticket_type.actions.filter(({id}) => !not.includes(id));
            }
        },
        watch: {
            selected_booking: {
                handler(val) {
                    this.action.paid = val.paid;
                },
                deep: true
            },
            async selected_action(val) {
                if (val) {
                    if (val === 'GIVE_PENALTY')
                        this.action.unit = "CASH";
                    else if (val === "VOUCHER_GIFT")
                        this.action.type = "CASH";
                    else if (val === 'EDIT_RIDE') {
                        this.loading = true;
                        await this.axios(this.api.ACTIONS.RIDE + '/' + (this.ticket.subject_type === 'App\\Models\\Ride\\Ride' ? this.ticket.subject_id : (this.ticket.ride_id + `?booking_id=${this.ticket.subject_id}`)))
                            .then(({data}) => {
                                this.ride = data.data;
                                if (this.ride.meter) {
                                    this.action.meter_price = this.ride.meter.meter_price;
                                }
                                this.ride.bookings.forEach(elem => elem.passenger_name = elem.passenger.first_name + ' ' + elem.passenger.last_name)
                            })
                            .catch((err) => console.log(err.message));
                        this.loading = false
                    }
                    this.dialog = true;
                }
            },
            dialog(val) {
                if (!val) {
                    this.selected_action = null;
                }
            }
        }
    }
</script>

<style scoped>
    * >>> .v-treeview-node__content, * >>> .v-treeview-node__label {
        flex-shrink: 1;
    }

    * >>> .v-treeview-node__root {
        height: auto;
    }

</style>
